import { atom, atomFamily } from 'recoil';
import { PartyBankAccount, PartyCommunicationChannel as PartyCommunicationChannelUtil, } from '../../utils/notMigratedYet';
export const localPartyAtom = atom({
    key: 'local/party',
    default: {
        partyType: 'N',
        partySubType: 'P',
        preferredLanguage: 'DEU',
        lastName: '',
    },
});
export const localPartyCommunicationChannelAtomFamily = atomFamily({
    key: 'local/partyCommunicationChannel',
    default: (communicationChannelType) => PartyCommunicationChannelUtil.createDefault(communicationChannelType),
});
export const localPartyCustomerRequestAtom = atom({
    key: 'local/partyCustomerRequestMessage',
    default: undefined,
});
export const localPartyBankAccountAtom = atom({
    key: 'local/partyBankAccount',
    default: PartyBankAccount.createDefault(),
});
export const localPartyInsolvencyAtom = atom({
    key: 'local/partyInsolvency',
    default: {},
});
export const localPartyRelationAtom = atom({
    key: 'local/partyRelation',
    default: {
        partyA: null,
        partyB: null,
        partyRelationType: null,
    },
});
export const localPartyHouseholdMoveTypeAtom = atom({
    key: 'local/partyHouseholdMoveType',
    default: null,
});
export const localPartyHouseholdMergeSelectionAtom = atom({
    key: 'local/partyHouseholdMergeSelection',
    default: null,
});
export const localPartyPepSanctionStatusAtom = atom({
    key: 'local/partyPepSanctionStatus',
    default: {},
});
